const PDFObject = require('pdfobject');
const pdfAttacheds = document.querySelectorAll('.attached-item[data-mimetype="application/pdf"]');
if ( pdfAttacheds.length > 0 ) {
    Array.from(pdfAttacheds).map(item=>{
        const {fileUrl, canvas} = item.dataset;
        PDFObject.embed(fileUrl, canvas, {
            width: '100%',
            height: '1200px',
            // 모바일 등 PDF 미리보기를 지원하지 않는 브라우저에 보여줄 안내 ([url]은 PDFObject가 파일 주소로 치환)
            fallbackLink: "<div class='text-center py-3'>"
                + "<p class='mb-3'>이 브라우저에서는 PDF 미리보기를 지원하지 않습니다.<br>파일을 내려받아 확인해 주세요.</p>"
                + "<a href='[url]' class='btn btn-primary rounded-pill px-4' target='_blank' rel='noopener'>PDF 다운로드</a>"
                + "</div>"
        });
    })
}
